export interface UserHasGrantFlightdocs {
  hasGrant: boolean;
  clientId: string;
  errorMessage: string;
}

export const POSITVE_USER_HAS_GRANT_FLIGHTDOCS: UserHasGrantFlightdocs = {
  hasGrant: true,
  clientId: '',
  errorMessage: ''
};

export const NEGATIVE_USER_HAS_GRANT_FLIGHTDOCS: UserHasGrantFlightdocs = {
  hasGrant: true,
  clientId: '',
  errorMessage: ''
};
